import React from 'react';
import {Dates} from '../utils';

const useTimeDifference = (timestamp: number | null | undefined) => {
  const [formatted, setFormatted] = React.useState(() =>
    timestamp ? Dates.formatTimeDifference(timestamp) : '',
  );

  React.useEffect(() => {
    if (timestamp) {
      setFormatted(Dates.formatTimeDifference(timestamp));
      const interval = setInterval(
        () => setFormatted(Dates.formatTimeDifference(timestamp)),
        1000,
      );
      return () => clearInterval(interval);
    } else {
      setFormatted('');
    }
  }, [timestamp]);

  return formatted;
};

export default useTimeDifference;
